// extracted by mini-css-extract-plugin
module.exports = {"badge":"ProductBadge_badge__oPIFl","hotdeal":"ProductBadge_hotdeal__bWJY4","freeDelivery":"ProductBadge_freeDelivery__i9JOd"};